// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.noDataContainer_KUqPf.win_rOl5T {
  display: flex;
  align-items: center !important;
  justify-content: center !important;
  flex-wrap: wrap;
  height: 100%;
}

.mobileContent_DWYP6 {
  display : flex;
  flex-direction : column;
  height : 100%;
  align-items : center;
  justify-content: center;
  padding : 16px;
}

.image_W04tl {
  max-width: 200px;
  max-height: 200px;
  margin-right: 36px;
}

.mobileImage_d7FSA {
  max-width: 200px;
  max-height: 200px;
  margin-bottom: 36px;
}

.bold_dpUrh {
  font-weight: 700 !important;
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/molten/lib/screens/support/MissingRelationshipScreen/Shared.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;EAC9B,kCAAkC;EAClC,eAAe;EACf,YAAY;AACd;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,aAAa;EACb,oBAAoB;EACpB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B","sourcesContent":[".noDataContainer.win {\n  display: flex;\n  align-items: center !important;\n  justify-content: center !important;\n  flex-wrap: wrap;\n  height: 100%;\n}\n\n.mobileContent {\n  display : flex;\n  flex-direction : column;\n  height : 100%;\n  align-items : center;\n  justify-content: center;\n  padding : 16px;\n}\n\n.image {\n  max-width: 200px;\n  max-height: 200px;\n  margin-right: 36px;\n}\n\n.mobileImage {\n  max-width: 200px;\n  max-height: 200px;\n  margin-bottom: 36px;\n}\n\n.bold {\n  font-weight: 700 !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"noDataContainer": `noDataContainer_KUqPf`,
	"win": `win_rOl5T`,
	"mobileContent": `mobileContent_DWYP6`,
	"image": `image_W04tl`,
	"mobileImage": `mobileImage_d7FSA`,
	"bold": `bold_dpUrh`
};
export default ___CSS_LOADER_EXPORT___;
